const useGEData = {
  level1: {
    useGE: ["GE2558-ปวช."],
  },
  level2: { useGE: ["GE2558-ปวส.", "GE2565-ปวส.","GE2565-ปวส.(ใหม่)"] },
  level3: {
    useGE: [
      "GE2558-ค.อ.บ.",
      "GE2558-อส.บ.",
      "GE2558-ศศ.บ.",
      "GE2565-ค.อ.บ.",
      "GE2565-อส.บ.",
      "GE2565-ศศ.บ.",
    ],
  },
  level4: { useGE: ["GE2558-ป.โท"] },
};

export default useGEData;
